import { render, staticRenderFns } from "./InputGeneric.vue?vue&type=template&id=56b3405a&scoped=true&lang=pug"
import script from "./InputGeneric.vue?vue&type=script&lang=ts"
export * from "./InputGeneric.vue?vue&type=script&lang=ts"
import style0 from "./InputGeneric.vue?vue&type=style&index=0&id=56b3405a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3405a",
  null
  
)

export default component.exports